import { createEvent } from '../../shared/utils/tracking.utils';

// Device alerts (Signal Center): how people reach the devices page, what they open there, and who gets alerts.

export const devicesOpened = createEvent<{
  from: 'bell' | 'settings menu';
  // Open alerts at the location when opened (the bell's badge count).
  openAlerts: number;
}>('Devices opened');

export const usersOpened = createEvent<{
  // The orange "no alert recipient" dot was showing on the Users item.
  missingAlertRecipient: boolean;
}>('Users opened');

export const alertDetailsOpened = createEvent<{
  deviceType: string;
  viewerRole: string;
}>('Alert details opened');

export const deviceDetailsOpened = createEvent<{
  deviceType: string;
  online: boolean;
}>('Device details opened');

export const alertRecipientChanged = createEvent<{
  enabled: boolean;
  newUser: boolean;
}>('Alert recipient changed');
